module.exports = __webpack_public_path__ + "img/02-424-424-01.5213416a.png";